import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {PostfachContentComponent} from './postfach-content/postfach-content.component';
import {HeaderComponent} from '../core/components/header/header.component';
import {Rechte} from '../core/model/rechte.model';
import {NachrichtenOrdner} from '../core/model/nachrichten-ordner';
import {PagesEnum} from '../core/model/pages.enum';
import {ActivatedRoute} from '@angular/router';
import {OrdnerEnum} from '../core/model/ordner.enum';
import {
  PostfachEingeschraenktComponent
} from "../core/components/postfach-eingeschraenkt/postfach-eingeschraenkt.component";
import {UserAccountService} from "../core/services/user-account.service";
import {I18NextPipe} from "@kokos-i18next";

@Component({
  selector: 'kokos-postfach-overview',
  imports: [
    HeaderComponent, PostfachContentComponent, PostfachEingeschraenktComponent, I18NextPipe
  ],
  templateUrl: './postfach.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PostfachComponent implements OnInit {

  benutzerRechte: Rechte = null;
  nachrichtenOrdner: NachrichtenOrdner[] = [];
  selectedFolder = OrdnerEnum.ERHALTEN;
  page = PagesEnum.Mailbox;
  isZuwanderungsinteressierter: boolean = false;
  postfachRestricted = false;

  private readonly userAccountService = inject(UserAccountService);
  private readonly route =  inject(ActivatedRoute);

  ngOnInit() {
    this.route.data.subscribe((data: any) => {
      this.benutzerRechte = data.combined.benutzerRechte;
      this.nachrichtenOrdner = data.combined.ordnerList;
      this.isZuwanderungsinteressierter = this.userAccountService.isZuwanderungsinteressierter();
      this.postfachRestricted = this.userAccountService.isRestricted();
    });
    this.route.paramMap.subscribe(params => {
      this.selectedFolder = params.get('ordner') as OrdnerEnum;
    });
  }
}